import { reactive } from "vue";
import { resolveMethodKey } from "./analysis.bridge";
/**
 * @typedef {'service' | 'vehicle'} PlanType
 */
export const METHOD_KEYS = [
    "method1",
    "method2",
    "method3",
    "method4_0",
    "method4_10",
    "method4_20",
    "method4_30",
    "method5",
    "method6",
];
export function createEmptyServicePlansByMethod() {
    return Object.fromEntries(METHOD_KEYS.map((key) => [key, { gidis: [], donus: [] }]));
}
export function createEmptyVehiclePlansByMethod() {
    return Object.fromEntries(METHOD_KEYS.map((key) => [key, []]));
}
export function createEmptyUserModificationsByMethod() {
    return Object.fromEntries(METHOD_KEYS.map((key) => [
        key,
        {
            parkurSureleri: {},
            addedServices: [],
            removedServices: [],
            modifiedServices: [],
        },
    ]));
}
export function createFrequencyState() {
    return {
        basePlans: createEmptyServicePlansByMethod(),
        activePlans: createEmptyServicePlansByMethod(),
        vehiclePlans: createEmptyVehiclePlansByMethod(),
        userModifications: createEmptyUserModificationsByMethod(),
        currentPlanType: "service",
        needsRefresh: false,
        /** methodKey → servis değişti, araç planı path-cover bekliyor */
        vehiclePathCoverDirty: {},
    };
}
export const frequencyGetters = {
    /** Vuex: currentServicePlan */
    currentServicePlan(state) {
        const methodKey = resolveMethodKey();
        return state.activePlans[methodKey] || { gidis: [], donus: [] };
    },
    /** Vuex: currentVehiclePlan */
    currentVehiclePlan(state) {
        const methodKey = resolveMethodKey();
        return reactive(state.vehiclePlans[methodKey]) || [];
    },
    /** Vuex: getMethodKey */
    getMethodKey() {
        return resolveMethodKey();
    },
    /** Vuex: hasActivePlan */
    hasActivePlan: (state) => (methodKey) => !!state.activePlans[methodKey] &&
        (state.activePlans[methodKey].gidis.length > 0 ||
            state.activePlans[methodKey].donus.length > 0),
    /** Vuex: currentPlanType */
    currentPlanType: (state) => state.currentPlanType,
};
